import {useState} from 'react';
import {Row, Col, Modal, Input} from 'antd';
import {toFSDate} from "../../util/timeutils";
import * as dayjs from 'dayjs'
import {DatePickerWidget} from "../widget/DatePickerWidget";

const {TextArea} = Input;

export const DateNotePickerWidget = ({date, placeholder, onChange, disabled, minDate, maxDate, children, props}) => {
    const [active, setActive] = useState(false);
    const [dateVal, setDateVal] = useState(date);
    const [notes, setNotes] = useState(undefined);

    const [displayDate, setDisplayDate] = useState(date);

    const onClick = () => {
        if (disabled === true) {
            // disabled pickers can not be changed
            return;
        }
        setActive(true);
    }

    const onDateChange = (dateString, dateJS) => {
        setDateVal(dateString);

        const dateJsString = dateJS.toString();

        // we will set displayDate to a local time for DatePickerWidget
        setDisplayDate(dateJsString);
    }

    const onModalOk = () => {
        if (onChange) {
            onChange(dateVal, notes);
        }
        setActive(false);
        setNotes(undefined);
    }

    const onModalCancel = () => {
        setActive(false);
        setNotes(undefined);
    }

    const onNotesChange = (e) => {
        setNotes(e.target.value);
    }

    let dateContent;
    if (date) {
        dateContent = toFSDate(new Date(date));
    } else {
        dateContent = `${placeholder}`
    }

    const minDateJS = (minDate !== undefined) ? dayjs(minDate) : undefined;
    const maxDateJS = (maxDate !== undefined) ? dayjs(maxDate) : undefined;

    const divStyle = {marginTop: '10px', marginBottom: '10px'};
    const okProps = {
        disabled: (notes === undefined) || (notes.length === 0)
    }

    return <div>
        <Modal title={'Modify Due Date'} open={active} onOk={onModalOk} okButtonProps={okProps} onCancel={onModalCancel}>
            <div style={divStyle}>
            <DatePickerWidget date={displayDate} placeholder={placeholder} onChange={onDateChange} minDate={minDateJS} maxDate={maxDateJS}/>
            </div>
            <div style={divStyle}>
            <TextArea placeholder={"Reason for Due Date Change"} value={notes} rows={4} maxLength={2048} onChange={onNotesChange} />
            </div>
        </Modal>
        <div style={{cursor: "pointer", color: "#108ee9", marginTop: '5px'}} onClick={onClick}>
        <Row>
            <Col style={{marginRight: '5px'}}>
                {dateContent}
            </Col>
            <Col>
                {children}
            </Col>
        </Row>
        </div>
    </div>
}